import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminLayout from '../../components/layout/AdminLayout';
import api from '../../utils/api';

export default function DashboardPage() {
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => { loadStats(); }, []);

  const loadStats = async () => {
    try {
      const { data } = await api.get('/admin/stats');
      setStats(data.stats);
    } catch {
      setStats({ users:{farmers:0,buyers:0,agents:0}, crops:{total:0,growing:0,ready:0,sold:0,closed:0,newThisWeek:0} });
    } finally { setLoading(false); }
  };

  const STAT_CARDS = stats ? [
    { label:'Farmers',      value:stats.users?.farmers||0,     icon:'🧑‍🌾', cls:'stat-card--green',  link:'/farmers' },
    { label:'Buyers',       value:stats.users?.buyers||0,      icon:'🛒',   cls:'stat-card--blue',   link:'/buyers' },
    { label:'Agents',       value:stats.users?.agents||0,      icon:'🤝',   cls:'stat-card--purple', link:'/agents' },
    { label:'Total Crops',  value:stats.crops?.total||0,       icon:'',   cls:'stat-card--green',  link:'/crops' },
    { label:'Ready to Sell',value:stats.crops?.ready||0,       icon:'🟢',   cls:'stat-card--amber',  link:'/crops' },
    { label:'New This Week',value:stats.crops?.newThisWeek||0, icon:'📅',   cls:'stat-card--blue',   link:'/crops' },
  ] : [];

  const QUICK = [
    { label:'Fix stuck crop',  icon:'🔒', path:'/crops' },
    { label:'Ban user',        icon:'🚫', path:'/users' },
    { label:'Send broadcast',  icon:'📢', path:'/notifications' },
    { label:'Support tickets', icon:'🎧', path:'/support' },
    { label:'Add admin',       icon:'👤', path:'/settings' },
    { label:'Export report',   icon:'📊', path:'/crops' },
  ];

  return (
    <AdminLayout title="Dashboard">
      {loading ? (
        <div className="page-loader"><span className="spinner spinner--lg" /><span>Loading...</span></div>
      ) : (
        <>
          <div className="stat-grid">
            {STAT_CARDS.map(s => (
              <div key={s.label} className={"stat-card " + s.cls} style={{ cursor:"pointer" }} onClick={() => navigate(s.link)}>
                <div className="stat-card__icon">{s.icon}</div>
                <div className="stat-card__label">{s.label}</div>
                <div className="stat-card__value">{s.value}</div>
              </div>
            ))}
          </div>

          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16, marginBottom:20 }}>
            <div className="card">
              <div className="card__header"><div className="card__title"> Crop Breakdown</div></div>
              <div className="card__body">
                {[
                  { label:"Growing",       value:stats?.crops?.growing||0,  color:"#16A34A" },
                  { label:"Ready to Sell", value:stats?.crops?.ready||0,    color:"#2563EB" },
                  { label:"Sold",          value:stats?.crops?.sold||0,     color:"#D97706" },
                  { label:"Closed",        value:stats?.crops?.closed||0,   color:"#ADB5BD" },
                ].map(item => {
                  const pct = Math.round(((item.value)/(stats?.crops?.total||1))*100);
                  return (
                    <div key={item.label} style={{ marginBottom:12 }}>
                      <div className="flex-between" style={{ marginBottom:4 }}>
                        <span style={{ fontSize:12, color:"#6C757D" }}>{item.label}</span>
                        <span style={{ fontSize:12, fontWeight:600 }}>{item.value} <span style={{ color:"#ADB5BD" }}>({pct}%)</span></span>
                      </div>
                      <div className="progress"><div className="progress__bar" style={{ width:pct+"%", background:item.color }} /></div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="card">
              <div className="card__header"><div className="card__title">⚡ Quick Actions</div></div>
              <div className="card__body">
                <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8 }}>
                  {QUICK.map(a => (
                    <button key={a.label} onClick={() => navigate(a.path)}
                      style={{ background:"#f8f9fa", border:"1px solid #e9ecef", borderRadius:8, padding:"10px 12px", textAlign:"left", cursor:"pointer" }}>
                      <div style={{ fontSize:18, marginBottom:4 }}>{a.icon}</div>
                      <div style={{ fontSize:12, fontWeight:600, color:"#212529" }}>{a.label}</div>
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </AdminLayout>
  );
}
